define('viewmodels/app/__config',[], function() {
    'use strict';

    return {
        REPORT_SCHEDULE_CONTEXT_IDS: {
            DASHBOARD: 'DASHBOARD',
            REPORTS: 'REPORTS'
        }
    };
});

